import { useEffect, useRef, useState } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import decodeRelativeDates from '@afosto/utils-react/date/decodeRelativeDates';
import formatDateTime from '@afosto/utils/date/formatDateTime';
import isDateTypeToday from './isDateTypeToday';
import translations from '../../DateOptions/translations';

export default ({ operator, value, formatter = formatDateTime }) => {
  const intl = useIntl();
  const [dateValue, setDateValue] = useState(null);
  const [isToday, setIsToday] = useState(false);
  const operatorRef = useRef(operator);
  const formatterRef = useRef(formatter);

  useEffect(() => {
    operatorRef.current = operator;
    formatterRef.current = formatter;
  });

  useEffect(() => {
    const valueFormatter = formatterRef.current;

    const decodeDateValues = async () => {
      try {
        const decodedValues = await decodeRelativeDates(value);
        const todayValues = decodedValues
          .filter(
            decodedValue =>
              !decodedValue?.query?.at?.day_of_week && !decodedValue?.query?.at?.day_of_month,
          )
          .map(decodedValue => decodedValue?.formatted)
          .filter(formattedValue => formattedValue);

        if (isDateTypeToday(operatorRef?.current, todayValues)) {
          setIsToday(true);
        } else {
          const formattedValues = decodedValues
            .map(decodedValue => decodedValue?.formatted)
            .filter(formattedValue => formattedValue);
          const values = formattedValues.map(formattedValue =>
            valueFormatter(new Date(formattedValue)),
          );

          setDateValue(values);
          setIsToday(false);
        }
      } catch (err) {
        setDateValue(null);
        setIsToday(false);
      }
    };

    if (value && value?.length > 0) {
      const [firstValue] = value;

      if (firstValue && typeof firstValue === 'string' && firstValue?.startsWith('_')) {
        decodeDateValues().catch(() => {
          // Catch only.
        });
      } else {
        const values = value.map(formattedValue =>
          formattedValue ? valueFormatter(new Date(formattedValue)) : null,
        );
        setDateValue(values);
        setIsToday(false);
      }
    } else {
      setDateValue(null);
      setIsToday(false);
    }
  }, [value]);

  let displayOperator = operator;
  let displayValue = dateValue;

  if (isToday && operator === 'between') {
    displayOperator = 'is';
  }

  if (isToday) {
    displayValue = intl.formatMessage(translations.dateOptions.today).toLowerCase();
  }

  return [displayValue, displayOperator];
};
